export const GET_CURRENT_USER = 'GET_CURRENT_USER';

export const LOGIN = 'LOGIN';
export const LOGIN_RUNNING = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT = 'LOGOUT';
